// extracted by mini-css-extract-plugin
module.exports = {"probox":"detail_probox_24IC_","twoLines":"detail_twoLines_34Sa1","pro":"detail_pro_1w40C","imgBox":"detail_imgBox_2U5_D"};